<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }"
                >项目管理</el-breadcrumb-item
            >
            <el-breadcrumb-item>批量发布项目</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box pro-detail__wraper">
            <div class="pro-status-area">
                <el-steps
                    style="padding: 31px 0;"
                    :active="activeStep"
                    align-center
                    finish-status="success"
                >
                    <el-step title="提交项目数据" description=""></el-step>
                    <el-step title="确认需求信息" description=""></el-step>
                    <el-step title="发布成功" description=""></el-step>
                </el-steps>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Check',
    data () {
        return {
            activeStep: 1
        }
    },
    mounted () {
        this.indexWatch()
    },
    watch: {
        $route: 'indexWatch'
    },
    methods: {
        indexWatch () {
            if (this.$route.path.substr(-1, 1) * 1 === 2) {
                this.activeStep = 2
            } else if (this.$route.path.substr(-1, 1) * 1 === 3) {
                this.activeStep = 3
            } else {
                this.activeStep = 1
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/var";
@import "../../assets/style/sub.scss";
</style>
